@if (!loading) {
  <div [class.compact]="compactClientView">
    @if (verificationsOrOptions.length > 0) {
      <table class="table table-sm"
        >
        <thead [ngClass]="{ 'table-dark': dark }">
          <tr>
            <th>
              Referral Date
            </th>
            <th>
              Referral Type
            </th>
            <th>
              Referral Notes
            </th>
            <th>
              Specialty
            </th>
            <th>
              Prescriber
            </th>
            @if (!compactClientView) {
              <th>
                Additional Details
              </th>
            }
            @if (!compactClientView) {
              <th>
                Task ID
              </th>
            }
            @if (!compactClientView) {
              <th>
                Submitted By
              </th>
            }
            @if (!compactClientView) {
              <th>
                Submitted At
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (item of verificationsOrOptions; track item; let i = $index) {
            <tr
              [class.selected]="option(item)?.selected"
              class="referral">
              <td>
                @if (option(item)) {
                  <div
                    class="form-check"
                    [ngClass]="{ disabled: option(item).disabled }">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      [id]="'clientTaskRmv' + i"
                      [(ngModel)]="option(item).selected"
                      [disabled]="option(item).disabled"
                      (change)="onReferralVerificationChange(option(item))">
                    <label class="form-check-label" [for]="'clientTaskRmv' + i">
                      {{ verification(item).referralDate | date: 'MM/dd/yyyy' }}
                    </label>
                  </div>
                }
                @if (!option(item)) {
                  <div>
                    {{ verification(item).referralDate | date: 'MM/dd/yyyy' }}
                  </div>
                }
              </td>
              <td>
                {{ verification(item).clientReferralTaskSubmission.choiceReasons | referralVerificationReasonShortNames | joinList }}
              </td>
              <td>
                {{ verification(item).clientReferralTaskSubmission.choiceOtherReasonNote | blankValueDash }}
              </td>
              <td>
                {{ verification(item).referralSpecialty | blankValueDash }}
              </td>
              <td>
                <div>{{ verification(item).provider?.fullName }}</div>
                <div>NPI: {{ verification(item).provider?.npi }}</div>
                <div>{{ verification(item).provider?.displaySpecialty }}</div>
              </td>
              @if (!compactClientView) {
                <td class="phi">
                  {{ verification(item).clientReferralTaskSubmission.notes | blankValueDash }}
                </td>
              }
              @if (!compactClientView) {
                <td>
                  {{ verification(item).clientReferralTaskSubmission.taskId }}
                </td>
              }
              @if (!compactClientView) {
                <td>
                  {{ verification(item).clientReferralTaskSubmission.submittedBy.fullName }}
                </td>
              }
              @if (!compactClientView) {
                <td>
                  <div>{{ verification(item).clientReferralTaskSubmission.submittedAt | date: 'MM/dd/yyyy' }}</div>
                  <div>{{ verification(item).clientReferralTaskSubmission.submittedAt | date: 'h:mm a' }}</div>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <div class="my-2">Patient has no applicable referral tasks.</div>
    }
  </div>
} @else {
  <div class="mt-1 mb-2 ms-1"><mat-spinner diameter="30" /></div>
}


